import React, { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";

import DesktopCalendars from "./DesktopCalendars";
import MobileCalendars from "./MobileCalendars";
import "antd/dist/reset.css";
import "./index.css";
import getDeviceType from "@/app/utils/device/getDeviceType";
import { useTheme } from "next-themes";

// to start schema from monday instead of sunday
dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});

const CustomDatePicker = () => {
  const { resolvedTheme } = useTheme();
  const [deviceType, setDeviceType] = useState({
    isMobileType: false,
    isTabletType: false,
  });

  useEffect(() => {
    setDeviceType(getDeviceType());
  }, []);

  const shouldRenderMobile = deviceType.isMobileType || deviceType.isTabletType;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#42E6FF",
          colorBgContainer: resolvedTheme == "light" ? "#fafafa" : "#09090b",
          colorText: resolvedTheme == "light" ? "#3f3f46" : "white",
          colorBgElevated: resolvedTheme == "light" ? "white" : "black",
          colorTextDisabled: "grey",
          colorBorderSecondary:
            resolvedTheme == "light" ? "#a1a1aa" : "#ffffff80",
        },
      }}
    >
      {shouldRenderMobile ? <MobileCalendars /> : <DesktopCalendars />}
    </ConfigProvider>
  );
};

export default CustomDatePicker;
